import Image from 'next/dist/client/image'
import { useTranslation } from 'hooks/useTranslation'
import { Button } from 'components/Button'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { PostContent, PostContentType } from '../PostContent/PostContent'
import { PostImageType } from '../PostImage/PostImage'
import { PostBannerRoot, ContentWrapper, ImageContainer } from './PostBanner.styles'

import * as isologo from '../../../../../../../public/assets/isologo.svg'
import { Link } from 'components/Link'

export type PostBannerType = {
  fields: {
    bannerColor: string
    bannerCta: string
    bannerLink: string
    bannerTitle: string
    bannerText: PostContentType
    bannerImage: PostImageType
  }
}

type PostBannerProps = {
  content: PostBannerType
}

export const PostBanner = ({ content }: PostBannerProps) => {
  const { t } = useTranslation()

  const { bannerColor, bannerCta, bannerLink, bannerTitle, bannerText, bannerImage } =
    content.fields

  return (
    <PostBannerRoot css={{ backgroundColor: bannerColor }}>
      <Stack
        direction={{ '@initial': 'column', '@bp2': 'row' }}
        gap={{ '@initial': '4', '@bp2': '7' }}
        alignItems="center"
      >
        <ImageContainer>
          <div className="isologo">
            <Image src={isologo} width={120} height={120} alt="logo" />
          </div>
          <img src={bannerImage.fields.file.url} alt={t('blog:ad-alt')} />
        </ImageContainer>

        <Stack
          alignItems={{ '@initial': 'center', '@bp2': 'flex-start' }}
          direction="column"
          gap={{ '@initial': '4', '@bp2': '5' }}
        >
          <Text align={{ '@initial': 'center', '@bp2': 'left' }}>
            <Stack direction="column" gap={{ '@initial': '2', '@bp2': '3' }}>
              <Text as="h2" size="h1" weight="medium">
                {bannerTitle}
              </Text>

              <ContentWrapper>
                <PostContent content={bannerText} />
              </ContentWrapper>
            </Stack>
          </Text>

          <div>
            <Link href={bannerLink} passHref>
              <Button as="a" variant="primary">
                {bannerCta}
              </Button>
            </Link>
          </div>
        </Stack>
      </Stack>
    </PostBannerRoot>
  )
}
